import gsap from "gsap";
import {createLogger} from "./util/logger.js";

const console = createLogger("WavePageTransition");

/**
 * Manages Wave Page Transition
 */
export class WavePageTransition {

    get animationOptions() {
        return {
            duration: 1,
            ease: "power3.inOut",
            ...this.opts,
            onUpdate: this.onUpdate,
        };
    }

    constructor(el, opts = {}) {

        this.opts = opts;

        /**
         * @type {HTMLDivElement}
         */
        this.$overlay = el;

        /**
         * @type {HTMLCanvasElement}
         */
        this.$canvas = this.$overlay.querySelector("canvas");

        /**
         * @type {CanvasRenderingContext2D}
         */
        this.ctx = this.$canvas.getContext("2d");

        this.color = opts.color || "#0F111F";

        this.resolution = 40;
        this.amplitude = 250;
        this.progress = 0;

        requestAnimationFrame(() => {
            const overlayRect = el.getBoundingClientRect();
            this.$canvas.height = overlayRect.height;
            this.$canvas.width = overlayRect.width;
        });

        this.onUpdate = this.onUpdate.bind(this);
        console.log(this);
    }

    /**
     * Plays the show animation
     * @param {1|-1} direction 1 For up, -1 for down
     * @return {Promise<unknown>}
     */
    show(direction = 1) {
        this.progress = 0;
        return this.animate(direction, 1);
    }

    /**
     * Plays the hide animation
     * @return {Promise<unknown>}
     */
    hide(direction = -1) {
        this.progress = 1;
        return this.animate(direction, 0);
    }

    animate(direction, progress = 1) {
        return new Promise((resolve) => {
            gsap.set(this.$canvas, { rotation: direction === -1 ? 180 : 0});

            gsap.to(this, {
                ...this.animationOptions,
                progress,
                onComplete: resolve,
            });
        });
    }




    // Event callbacks.

    onUpdate() {
        const {width, height} = this.$canvas;

        this.ctx.clearRect(0, 0, width, height);
        this.ctx.save();

        this.ctx.fillStyle = this.color;

        this.ctx.beginPath();
        this.widthSegments = Math.ceil(width / this.resolution);
        this.ctx.moveTo(width, height);
        this.ctx.lineTo(0, height);


        const t = (1 - this.progress) * height;
        const currentAmplitude = this.amplitude * Math.sin(this.progress * Math.PI);

        this.ctx.lineTo(0, t);

        for (let index = 0; index <= this.widthSegments; index++) {
            const x = this.resolution * index;
            const y = t - Math.sin((x / width) * Math.PI) * currentAmplitude;

            this.ctx.lineTo(x, y);
        }

        this.ctx.fill();
        this.ctx.restore();
    }
}
